import { required } from 'utils/validation'

export default function(values = {}) {
  return {
    name: required(values.name),
    date: required(values.date)
  }
}
